import type { CSSProperties, ReactNode } from 'react';

export interface RadioProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    label?: ReactNode;
    description?: ReactNode;
    /** Agrupa os botões: sem `name` o navegador não os trata como um grupo. */
    name?: string;
    disabled?: boolean;
    style?: CSSProperties;
}

export function Radio({ checked = false, onChange, label, description, name, disabled = false, style }: RadioProps) {
    return (
        <label
            style={{
                display: 'inline-flex', alignItems: description ? 'flex-start' : 'center', gap: 9,
                position: 'relative',
                cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, ...style,
            }}
        >
            <span
                aria-hidden="true"
                style={{
                    width: 16, height: 16, flex: '0 0 auto', marginTop: description ? 2 : 0, borderRadius: '50%',
                    border: `1px solid ${checked ? 'var(--burgundy-700)' : 'var(--border-strong)'}`,
                    background: 'var(--surface)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'var(--transition-control)',
                }}
            >
                {checked && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--burgundy-700)' }} />}
            </span>
            <input
                type="radio" name={name} checked={checked} disabled={disabled}
                onChange={() => onChange?.(true)}
                style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
            />
            {label && (
                <span style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <span style={{ fontSize: 14, lineHeight: '20px', color: 'var(--text-primary)' }}>{label}</span>
                    {description && <span style={{ fontSize: 12.5, lineHeight: '17px', color: 'var(--text-secondary)' }}>{description}</span>}
                </span>
            )}
        </label>
    );
}
